import { Component, inject, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Api } from '../../services/api';
import { RegionService } from '../../services/region.service'; 
import { AlertService } from '../../services/alert.service';
import { jwtDecode } from 'jwt-decode';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-mdl-manage-account',
  imports: [FormsModule,CommonModule],
  templateUrl: './mdl-manage-account.html',
  styleUrl: './mdl-manage-account.css'
})
export class MdlManageAccount implements OnInit{
  private api = inject(Api);
  private regionService = inject(RegionService); 

  public regiones: { NombreRegion: string }[] = [];
  public comunasFact: string[] = []; 
  public comunasEnv: string[] = []; 
  constructor(
    public mdl: MatDialogRef<MdlManageAccount>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private alertService: AlertService
  ) { }

  public accountOwnerName: string = '';
  public loggedUserName: string = '';

  public cuenta: any = {};
  public request: any = {
    cuenta_id: "",
    nombre_empresa: "",
    rut: "",
    industria_id: "",
    telefono: "",
    sitio_web: "",
    divisa_cuenta: "",
    empleados: "",
    linkedin: "",
    descripcion: "",
    direccion_fact: "",
    calle_fact: "",
    ciudad_fact: "",
    region_fact: "",
    pais_fact: "Chile", 
    direccion_env: "",
    calle_env: "",
    ciudad_env: "",
    region_env: "",
    pais_env: "Chile" 
  }

  public industrias: any = [];

  ngOnInit(): void {
     this.api.getdefaultAccountOwner().subscribe({
      next: (resp: any) => {
        const owner = resp.owner;
        this.accountOwnerName = `${owner.nombre} ${owner.apellido}`;
         this.request.ejecutivo_id = owner.usuario_id;
      },
      error: (err) => {
        console.error('Error obteniendo propietario por defecto:', err);
        this.accountOwnerName = 'Sebastián (por defecto)';
      }
    });
      const token = localStorage.getItem('crmtoken');
  if (token) {
    try {
      const decoded: any = jwtDecode(token);
      this.request.ejecutivo_id = decoded.userId; 
      this.loggedUserName = `${decoded.nombre} ${decoded.apellido}`; 
      console.log("nombre usuario logeado:", this.loggedUserName);
    } catch (error) {
      console.error('Error al decodificar token:', error);
      this.loggedUserName = 'Usuario desconocido';
    }
  }
    this.regiones = this.regionService.getRegionesFull();
    
    this.request.region_fact = this.regiones[0]?.NombreRegion || '';
    this.getComunasFact(this.request.region_fact);
    
    this.request.region_env = this.regiones[0]?.NombreRegion || '';
    this.getComunasEnv(this.request.region_env);

    this.getIndustries();

    if(this.data.mode === "edit"){
      this.cuenta = this.data.account;
      this.request.cuenta_id = this.cuenta.cuenta_id;
      this.request.nombre_empresa = this.cuenta.nombre_empresa || '';
      this.request.rut = this.cuenta.rut || '';
      this.request.industria_id = this.cuenta.industria_id || ''; 
      this.request.telefono = this.cuenta.telefono || '';
      this.request.sitio_web = this.cuenta.sitio_web || ''; 
      this.request.divisa_cuenta = this.cuenta.divisa_cuenta || '';
      this.request.ejecutivo_id = this.cuenta.ejecutivo_id || ''; 
      this.request.empleados = this.cuenta.empleados || '';
      this.request.linkedin = this.cuenta.linkedin || '';
      this.request.descripcion = this.cuenta.descripcion || '';
      this.request.direccion_fact = this.cuenta.direccion_fact || '';
      this.request.calle_fact = this.cuenta.calle_fact || '';
      this.request.ciudad_fact = this.cuenta.ciudad_fact || '';
      this.request.region_fact = this.cuenta.region_fact || '';
      this.request.pais_fact = "Chile"; 
      this.request.direccion_env = this.cuenta.direccion_env || '';
      this.request.calle_env = this.cuenta.calle_env || '';
      this.request.ciudad_env = this.cuenta.ciudad_env || '';
      this.request.region_env = this.cuenta.region_env || '';
      this.request.pais_env = "Chile"; 
      
      if (this.request.region_fact) {
        this.getComunasFact(this.request.region_fact);
      }
      if (this.request.region_env) {
        this.getComunasEnv(this.request.region_env);
      }
    }
  }

  getIndustries() {
    this.api.getIndustrias().subscribe({
      next: (data: any) => {
        this.industrias = data.data;
      },
      error: (err: any) => {
        console.error(err);
      }
    });
  }

  getComunasFact(region: string) {
    this.comunasFact = this.regionService.getComunasByRegion(region);
    if (this.comunasFact.length > 0 && !this.request.ciudad_fact) {
      this.request.ciudad_fact = this.comunasFact[0];
    }
  }

  getComunasEnv(region: string) {
    this.comunasEnv = this.regionService.getComunasByRegion(region);
    if (this.comunasEnv.length > 0 && !this.request.ciudad_env) {
      this.request.ciudad_env = this.comunasEnv[0];
    }
  }

  closeMdl(){
    this.mdl.close();
  }

  showMessage(msg: string, type: string) {
  switch (type) {
    case 'success':
      this.alertService.success('Éxito', msg);
      break;
    case 'error':
      this.alertService.error('Error', msg);
      break;
    default:
      this.alertService.info('Información', msg);
  }
}

  updateAccount(){
    this.api.showLoading();
    try {
      this.api.updateAccount(this.request).subscribe({
      next: (data:any) =>{
        setTimeout(() => {
          this.api.hideLoading();
          window.location.reload();
        }, 500);
      },
      error: (err: any) =>{
        console.error(err);
      }
    })
    } catch (error) {
      console.error(error);
    }
  }

  createAccount(){
    this.api.showLoading();
    try {
      const rutRegex = /^(\d{1,2}\.?\d{3}\.?\d{3}-[\dkK])$/;
      const phoneRegex = /^\+?\d{0,15}$/;

      if (!rutRegex.test(this.request.rut)) {
        console.log("RUT invalido:", this.request.rut);
           this.alertService.error('Error de validación', 'El formato del RUT es inválido');
        return;
      }
      if (this.request.telefono && !phoneRegex.test(this.request.telefono)) {
      setTimeout(() => {
        console.log("Telefono invalido:", this.request.telefono);
            this.alertService.error('Error de validación', 'Formato de teléfono no aceptado');
      }, 0);
          return;
      }
      this.api.createAccount(this.request).subscribe({
        next: (data:any) =>{
          setTimeout(() => {
            this.api.hideLoading();
            this.alertService.success('Éxito', 'Cuenta creada exitosamente');
            window.location.reload();
          }, 500);
        },
        error: (err: any) =>{
          console.error(err);
        }
      })
    } catch (error) {
      console.error(error);
    }
  }
}